module.exports = __webpack_public_path__ + "img/bg3.b93582d7.jpeg";